(() => {
  if (window.__organaxProductExtrasLoaded) return;
  window.__organaxProductExtrasLoaded = true;
  function init(root) {
    root.querySelectorAll('.organax-video-reviews:not([data-extras-ready])').forEach(section => {
      section.dataset.extrasReady = 'true';
      const track = section.querySelector('.organax-video-reviews__track');
      if (!track) return;
      const originals = [...track.querySelectorAll('.organax-video-reviews__card')];
      if (!originals.length) return;
      const count = originals.length;
      if (count > 1) {
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        originals.forEach(card => { before.append(card.cloneNode(true)); after.append(card.cloneNode(true)); });
        track.prepend(before);
        track.append(after);
      }
      const cards = [...track.querySelectorAll('.organax-video-reviews__card')];
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = count > 1 ? count : 0;
      let visible = false;
      let settleTimer;
      let dragStart;
      let suppressClickUntil = 0;

      const videoOf = card => card?.querySelector('video');
      const syncControls = card => {
        const video = videoOf(card);
        if (!video) return;
        card.dataset.muted = String(video.muted);
        card.dataset.playing = String(!video.paused && !video.ended);
        card.querySelector('[data-video-sound]')?.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        card.querySelector('[data-video-play]')?.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      };
      const playActive = () => {
        const video = videoOf(cards[activeIndex]);
        if (!video || !visible || reducedMotion.matches) return;
        video.muted = true;
        video.loop = true;
        video.play().catch(() => {});
      };
      const setActive = index => {
        activeIndex = index;
        cards.forEach((card, cardIndex) => {
          const active = cardIndex === index;
          const video = videoOf(card);
          card.classList.toggle('is-active', active);
          card.querySelectorAll('.organax-video-reviews__video-control').forEach(button => { button.hidden = !active; });
          if (video && !active) {
            video.pause();
            try { video.currentTime = 0; } catch (_) {}
            video.muted = true;
          }
          syncControls(card);
        });
        playActive();
      };
      const targetFor = index => {
        const card = cards[index];
        return track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left + card.getBoundingClientRect().width / 2 - track.clientWidth / 2;
      };
      const align = (index, smooth = true) => track.scrollTo({ left: targetFor(index), behavior: smooth && !reducedMotion.matches ? 'smooth' : 'auto' });
      const nearestIndex = () => {
        const center = track.getBoundingClientRect().left + track.clientWidth / 2;
        return cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left + card.getBoundingClientRect().width / 2 - center) < Math.abs(cards[best].getBoundingClientRect().left + cards[best].getBoundingClientRect().width / 2 - center) ? index : best, 0);
      };
      const finishScroll = () => {
        let index = nearestIndex();
        if (count > 1 && (index < count || index >= count * 2)) {
          index += index < count ? count : -count;
          track.style.scrollSnapType = 'none';
          align(index, false);
          requestAnimationFrame(() => { track.style.scrollSnapType = ''; });
        }
        setActive(index);
      };
      cards.forEach((card, index) => {
        const video = videoOf(card);
        if (!video) return;
        video.controls = false;
        video.muted = true;
        video.draggable = false;
        video.addEventListener('dragstart', event => event.preventDefault());
        card.querySelectorAll('.organax-video-reviews__video-control').forEach(button => { button.hidden = index !== activeIndex; });
        ['play', 'pause', 'volumechange', 'ended'].forEach(type => video.addEventListener(type, () => syncControls(card)));
        card.addEventListener('click', event => {
          if (performance.now() < suppressClickUntil) return;
          const sound = event.target.closest('[data-video-sound]');
          const play = event.target.closest('[data-video-play]');
          if (index !== activeIndex) { align(index); return; }
          if (sound) { video.muted = !video.muted; syncControls(card); }
          if (play) {
            if (video.paused) video.play().catch(() => {});
            else video.pause();
            syncControls(card);
          }
        });
        syncControls(card);
      });
      track.addEventListener('scroll', () => {
        if (dragStart?.didDrag) return;
        clearTimeout(settleTimer);
        settleTimer = setTimeout(finishScroll, 140);
      }, { passive: true });
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        align(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      });
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button')) return;
        clearTimeout(settleTimer);
        dragStart = { id: event.pointerId, x: event.clientX, left: track.scrollLeft, didDrag: false };
      });
      track.addEventListener('pointermove', event => {
        if (!dragStart || event.pointerId !== dragStart.id) return;
        const distance = event.clientX - dragStart.x;
        if (!dragStart.didDrag && Math.abs(distance) > 5) {
          dragStart.didDrag = true;
          track.style.scrollSnapType = 'none';
          track.setPointerCapture(event.pointerId);
        }
        if (dragStart.didDrag) {
          event.preventDefault();
          track.scrollLeft = dragStart.left - distance;
        }
      });
      const endDrag = event => {
        if (!dragStart || event.pointerId !== dragStart.id) return;
        const { x, didDrag } = dragStart;
        dragStart = undefined;
        if (!didDrag) return;
        suppressClickUntil = performance.now() + 350;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        track.style.scrollSnapType = '';
        let destination = nearestIndex();
        const distance = event.clientX - x;
        if (Math.abs(distance) > 40 && destination === activeIndex) destination += distance < 0 ? 1 : -1;
        destination = Math.max(0, Math.min(cards.length - 1, destination));
        align(destination);
        clearTimeout(settleTimer);
        settleTimer = setTimeout(finishScroll, reducedMotion.matches ? 0 : 350);
      };
      track.addEventListener('click', event => {
        if (performance.now() >= suppressClickUntil) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', event => { if (dragStart && !dragStart.didDrag) endDrag(event); });
      const visibilityObserver = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) playActive();
        else cards.forEach(card => videoOf(card)?.pause());
      }, { threshold: .2 });
      visibilityObserver.observe(section);
      track.style.scrollSnapType = 'none';
      align(activeIndex, false);
      requestAnimationFrame(() => { track.style.scrollSnapType = ''; });
      setActive(activeIndex);
      const onResize = () => align(activeIndex, false);
      window.addEventListener('resize', onResize);
      const onUnload = event => {
        if (!event.target.contains(section)) return;
        window.removeEventListener('resize', onResize);
        visibilityObserver.disconnect();
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:unload', onUnload);
    });
    root.querySelectorAll('.organax-ingredients:not([data-extras-ready])').forEach(section => {
      section.dataset.extrasReady = 'true';
      const image = section.querySelector('.organax-ingredients__image img');
      if (!image) return;
      image.dataset.activeIngredientImage = section.querySelector('.organax-ingredients__item[open] summary')?.dataset.ingredientImage || '';
      section.querySelectorAll('.organax-ingredients__item').forEach(item => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          section.querySelectorAll('.organax-ingredients__item').forEach(other => { if (other !== item) other.open = false; });
          const summary = item.querySelector('summary');
          if (summary.dataset.ingredientImage && summary.dataset.ingredientImage !== image.dataset.activeIngredientImage) {
            const nextImage = new Image();
            nextImage.onload = () => {
              if (!item.open) return;
              image.removeAttribute('srcset');
              image.src = nextImage.src;
              image.alt = summary.dataset.ingredientAlt || '';
              image.dataset.activeIngredientImage = summary.dataset.ingredientImage;
            };
            nextImage.src = summary.dataset.ingredientImage;
          }
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
